import React, { useEffect, useRef } from "react";
import "./Services.css";

import service1 from "./images/service1.jpg";
import service2 from "./images/service2.webp";

const Services = () => {

  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            entry.target.style.transitionDelay = `${index * 0.2}s`;
            entry.target.classList.add("service-show");
          }
        });
      },
      { threshold: 0.2 }
    );

    cardsRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });

  }, []);

  return (
    <div className="services">

      <div className="container">

        {/* HEADING */}
        <div className="text-center mb-5">
          <h2 className="main-title">— Our Services —</h2>
          <p className="sub-title">Reliable pest control for every space.</p>
        </div>

        {/* CARDS */}
        <div className="row justify-content-center g-5">

          {/* CARD 1 */}
          <div className="col-md-5 ">
            <div
              className="service-card hidden"
              ref={(el) => (cardsRef.current[0] = el)}
            >

              <div className="img-box">
                <img src={service1} alt="service" />

              </div>

              <div className="content">
                <h5>Commercial Pest Management</h5>
                <p>
                  Reliable pest control solutions for offices, hotels and industrial spaces.
                </p>
              </div>

            </div>
          </div>

          {/* CARD 2 */}
          <div className="col-md-5">
            <div
              className="service-card hidden"
              ref={(el) => (cardsRef.current[1] = el)}
            >

              <div className="img-box">
                <img src={service2} alt="service" />

              </div>

              <div className="content">
                <h5>Residential Pest Management</h5>
                <p>
                  Reliable pest control solutions for homes, apartments and residential spaces.
                </p>
              </div>

            </div>
          </div>

        </div>

      </div>

    </div>
  );
};

export default Services; 